import { useState, useContext } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { FaEnvelope, FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Admin/AdminAuth/AdminLogin.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const AdminLogin = () => {
  const { baseUrl, RegExpChecker, setAuthToken } = useContext(AppContext);
  const [adminemail, setadminEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const isFormValid =
    adminemail && password && !errors.email && !errors.password;

  const handleLogin = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("adminemail", adminemail);
    formData.append("password", password);

    //axios//
    axios
      .post(`${baseUrl}/admin/Auth/adminLogin`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        setadminEmail("");
        setPassword("");
        if (response.data.success === true) {
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem("adminemail", adminemail);
          localStorage.setItem("Password", password);
          navigate("/admin-dashboard");
        } else {
          alert("Invalid Credentials. Try again with correct one.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <div className="al-page">
      {/* Background blobs */}
      <div className="al-blob al-blob-1" />
      <div className="al-blob al-blob-2" />
      <div className="al-blob al-blob-3" />

      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} sm={10} md={8} lg={5}>
            {/* Logo */}
            <div className="text-center mb-4">
              <div className="al-logo-wrap mx-auto mb-3">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                    fill="#fff"
                  />
                  <circle cx="12" cy="9" r="2.5" fill="#1B9B82" />
                </svg>
              </div>
              <h4 className="al-brand-name">Trustidrive</h4>
              <span className="al-admin-chip">Admin Panel</span>
            </div>

            {/* Card */}
            <Card className="al-card">
              {/* Card top accent */}
              <div className="al-card-accent" />

              <Card.Body className="p-4 pt-4">
                <h5 className="al-title">Welcome Back 👋</h5>
                <p className="al-subtitle">Sign in to manage your dashboard</p>

                {error && (
                  <Alert
                    variant="danger"
                    dismissible
                    onClose={() => setError("")}
                    className="al-alert"
                  >
                    {error}
                  </Alert>
                )}

                <Form>
                  {/* Email */}
                  <Form.Group className="mb-3">
                    <Form.Label className="al-label">Email Address</Form.Label>
                    <div className="al-input-wrap">
                      <span className="al-input-icon">
                        <FaEnvelope size={13} />
                      </span>
                      <Form.Control
                        type="email"
                        placeholder="admin@trustidrive.com"
                        value={adminemail}
                        onChange={(e) => setadminEmail(e.target.value)}
                        className="al-input al-input-padded"
                      />
                    </div>
                  </Form.Group>

                  {/* Password */}
                  <Form.Group className="mb-1">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <Form.Label className="al-label mb-0">
                        Password
                      </Form.Label>
                      <span
                        role="button"
                        className="al-forgot"
                        onClick={() => navigate("/admin-forgot-password")}
                      >
                        Forgot password?
                      </span>
                    </div>
                    <div className="al-input-wrap">
                      <span className="al-input-icon">
                        <FaLock size={13} />
                      </span>
                      <Form.Control
                        type={showPwd ? "text" : "password"}
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => {
                          const value = e.target.value;
                          setPassword(value);

                          const regError = RegExpChecker("password", value);

                          setErrors((prev) => ({
                            ...prev,
                            password: value && regError ? regError : "",
                          }));
                        }}
                        className="al-input al-input-padded al-input-pwd"
                      />
                      <button
                        type="button"
                        className="al-eye-btn"
                        onClick={() => setShowPwd(!showPwd)}
                      >
                        {showPwd ? (
                          <FaEyeSlash size={14} />
                        ) : (
                          <FaEye size={14} />
                        )}
                      </button>
                    </div>
                  </Form.Group>

                  {/* Sign In Button */}
                  <Button
                    type="submit"
                    className="al-btn w-100 mt-4"
                    onClick={handleLogin}
                    disabled={!isFormValid || loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        />
                        Signing in...
                      </>
                    ) : (
                      "Sign In →"
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>

            <p className="al-footer text-center mt-3">
              © 2026 Trustidrive. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;
